/********************************************************************/
/*** Initially Implemeneted By Fahad Akbar(fahadakbar24@gmail.com) **/
/********************************************************************/

import{
  columnSelectorCtrl
} from '../directives/column-selector/controller';

angular
  .module('app.controllers')
  .controller('columnSelectModalCtrl', columnSelectorCtrl);



// WEBPACK FOOTER //
// ./scripts/shared/controllers/column-select-modal.js